import { customInstanceForCsv } from '@fukuri-admins/apis/client/base/axiosInstance';
import { getGetApiV1ThreeLetterCodePartnerAdminsClientsClientIdActivationCodeExportUrl } from '@fukuri-admins/apis/client/gen/endpoints';

/**
 * アクティベーションコードCSVダウンロード
 * @param threeLetterCode - 3文字コード
 * @param clientId - クライアントID
 * @returns CSVのBlobデータ
 */
export const fetchActivationCodesCsv = (
  threeLetterCode: string,
  clientId: number
): Promise<Blob> => {
  const url = getGetApiV1ThreeLetterCodePartnerAdminsClientsClientIdActivationCodeExportUrl(
    threeLetterCode,
    clientId
  );
  return customInstanceForCsv({
    url,
    method: 'GET',
  });
};
